/* =====================================================================
   PB NYHEDSBREV — popup + footer-formular (erstatter Klaviyo-formularerne).
   Tilmelding → pbcards.xx/apps/pb/subscribe (egen server) → Shopify-kunde med samtykke,
   sprog og mærker (nyhedsbrev · kilde:popup/footer · land:XX) til Shopify Messaging.
   Popuppen: vises efter X sek / Y % scroll / når musen forlader siden (computer) — det der sker først.
   Én gang pr. besøg; er den vist, hviler den i Z dage (også hvis kunden ignorerede den).
   Aldrig igen efter tilmelding. Venter hvis kurv/menu er åben.
   ===================================================================== */
(function () {
  'use strict';
  var d = document, w = window;
  var SUB = 'pbSub1', SEEN = 'pbPopSeen1';
  function t(k, f) { return (w.PB && PB.t && PB.t(k)) || f || k; }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- spam-beskyttelse (Cloudflare Turnstile) — hentes først ved brug ---------- */
  var tsLoading = null;
  function tsKey() {
    var c = (w.PB && PB.cfg && PB.cfg.ts) || {}, host = location.hostname.replace(/^www\./, '');
    var l2 = String(c.d2 || '').split(/[\s,]+/).filter(Boolean);
    return (l2.indexOf(host) >= 0 && c.k2) || c.k1 || '';
  }
  function tsLoad() {
    if (w.turnstile) return Promise.resolve();
    if (tsLoading) return tsLoading;
    tsLoading = new Promise(function (res) {
      w.pbTsSubReady = res;
      var s = d.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=pbTsSubReady'; s.async = true; d.head.appendChild(s);
    });
    return tsLoading;
  }
  function arm(form) {
    if (form._ts !== undefined || !tsKey()) return;
    form._ts = null; form._tok = '';
    tsLoad().then(function () {
      var box = form.querySelector('[data-pb-ts]'); if (!box) return;
      form._ts = w.turnstile.render(box, { sitekey: tsKey(), size: 'flexible', appearance: 'interaction-only',
        callback: function (tok) { form._tok = tok; }, 'expired-callback': function () { form._tok = ''; } });
    });
  }

  /* ---------- fælles tilmelding ---------- */
  function submit(form, done) {
    var email = String((form.querySelector('input[type=email]') || {}).value || '').trim();
    var err = form.querySelector('[data-pb-sub-err]');
    function fail(k) { if (err) { err.hidden = false; err.textContent = t(k); } }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { fail('sub_err_email'); return; }
    if (err) err.hidden = true;
    var btn = form.querySelector('button[type=submit]'); if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    fetch('/apps/pb/subscribe', {
      method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ email: email, locale: d.documentElement.lang || '', country: (w.PB && PB.cfg && PB.cfg.country) || '',
        source: form.getAttribute('data-source') || 'side', ts: form._tok || '', hp: (form.querySelector('.pb-hp') || {}).value || '' })
    }).then(function (r) { return r.json().catch(function () { return { ok: false, error: 'server' }; }); }).then(function (j) {
      if (j.ok) { ls(SUB, '1'); done(email); return; }
      fail({ email: 'sub_err_email', rate: 'sub_err_rate', bot: 'sub_err_bot' }[j.error] || 'sub_err');
      if (w.turnstile && form._ts) { try { w.turnstile.reset(form._ts); form._tok = ''; } catch (x) {} }
      if (j.error === 'server' && form.hasAttribute('action')) form.submit();           /* serveren væk → Shopifys egen formular */
    }).catch(function () {
      if (form.hasAttribute('action')) form.submit(); else fail('sub_err');
    }).then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); } });
  }

  /* footer-formularen (og andre [data-pb-sub-form] uden for popuppen) */
  Array.prototype.forEach.call(d.querySelectorAll('[data-pb-sub-form]'), function (form) {
    if (form.closest('[data-pb-pop]')) return;
    form.addEventListener('focusin', function () { arm(form); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submit(form, function () {
        var ok = d.createElement('p'); ok.className = 'pb-news__ok'; ok.textContent = t('sub_ok');
        form.replaceWith(ok);
      });
    });
  });

  /* ---------- popuppen ---------- */
  var pop = d.querySelector('[data-pb-pop]');
  if (!pop) return;
  var test = pop.hasAttribute('data-test');
  var days = Number(pop.getAttribute('data-days') || 7), last = Number(ls(SEEN) || 0);
  if (!test) {
    if (ls(SUB) === '1') return;
    if (last && Date.now() - last < days * 864e5) return;
    try { if (sessionStorage.getItem(SEEN)) return; } catch (e) {}
  }
  var card = pop.querySelector('.pb-pop__card'), form = pop.querySelector('[data-pb-sub-form]');
  var shown = false, t0 = Date.now(), timers = [];

  function open() {
    if (shown) return;
    if (d.documentElement.classList.contains('pb-lock') || d.documentElement.classList.contains('pb-mkt-open')) { timers.push(setTimeout(open, 3000)); return; }   /* kurv/menu eller "Skift til din butik" åben → vent */
    shown = true; timers.forEach(clearTimeout);
    w.removeEventListener('scroll', onScroll); d.removeEventListener('mouseout', onExit);
    ls(SEEN, String(Date.now())); try { sessionStorage.setItem(SEEN, '1'); } catch (e) {}
    pop.hidden = false; arm(form);
    void pop.offsetWidth; pop.classList.add('is-open');                       /* tving layout → animationen kører, også i en baggrundsfane */
    if (w.PB && PB.lock) PB.lock(true);
    setTimeout(function () { var i = form.querySelector('input[type=email]'); if (i && w.matchMedia('(pointer:fine)').matches) i.focus({ preventScroll: true }); }, 350);
  }
  function close() {
    if (!pop.classList.contains('is-open')) return;
    pop.classList.remove('is-open'); card.style.transform = '';
    if (w.PB && PB.lock) PB.lock(false);
    setTimeout(function () { pop.hidden = true; }, 380);
  }
  Array.prototype.forEach.call(pop.querySelectorAll('[data-pb-pop-close]'), function (b) { b.addEventListener('click', close); });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    submit(form, function () {
      pop.querySelector('[data-pb-pop-step="form"]').hidden = true;
      pop.querySelector('[data-pb-pop-step="done"]').hidden = false;
    });
  });
  var cp = pop.querySelector('[data-pb-copy]');
  if (cp) cp.addEventListener('click', function () {
    var code = cp.getAttribute('data-pb-copy'), lbl = cp.querySelector('[data-pb-copy-lbl]');
    (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () { lbl.textContent = t('popup_copied'); }, function () {});
  });

  /* mobil: træk kortet ned for at lukke */
  var sy = null;
  card.addEventListener('touchstart', function (e) { if (card.scrollTop <= 0) sy = e.touches[0].clientY; }, { passive: true });
  card.addEventListener('touchmove', function (e) { if (sy === null) return; var dy = e.touches[0].clientY - sy; if (dy > 0) card.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
  card.addEventListener('touchend', function (e) {
    if (sy === null) return; var dy = (e.changedTouches[0].clientY - sy); sy = null;
    if (dy > 90) close(); else card.style.transform = '';
  });

  /* udløsere: tid · scroll · musen forlader siden — det der kommer først (tidligst efter 5 sek) */
  var delay = Math.max(5, Number(pop.getAttribute('data-delay') || 20)) * 1000;
  var pct = Number(pop.getAttribute('data-scroll') || 0);
  function ready() { return Date.now() - t0 >= 5000; }
  function onScroll() {
    if (!pct || !ready()) return;
    var h = d.documentElement.scrollHeight - innerHeight; if (h > 200 && scrollY / h * 100 >= pct) open();
  }
  function onExit(e) { if (!e.relatedTarget && e.clientY <= 0 && ready()) open(); }
  timers.push(setTimeout(open, test ? 1500 : delay));
  if (pct) w.addEventListener('scroll', onScroll, { passive: true });
  if (pop.getAttribute('data-exit') === 'true' && w.matchMedia('(pointer:fine)').matches) d.addEventListener('mouseout', onExit);
})();
